import { render, staticRenderFns } from "./SInputNumber.vue?vue&type=template&id=5c5229da&scoped=true"
import script from "./sInputNumber.ts?vue&type=script&lang=ts&external"
export * from "./sInputNumber.ts?vue&type=script&lang=ts&external"
import style0 from "./SInputNumber.vue?vue&type=style&index=0&id=5c5229da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5229da",
  null
  
)

export default component.exports